// extracted by mini-css-extract-plugin
export default {"root":"sL5CyQjs83dgf2ls4M_7"};